import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useApiTokensStore } from '@stores/api-tokens'

import { getFirstQueryValue } from '@helpers/route'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const store = useApiTokensStore()

  const userId = Number(getFirstQueryValue(to.query?.user_id))
  store.setFilterUserId(userId > 0 ? userId : null)

  store.setFilterSearch(getFirstQueryValue(to.query?.search) || null)
})
